import { render, staticRenderFns } from "./MobileNavMenu.vue?vue&type=template&id=08359478&scoped=true"
import script from "./MobileNavMenu.vue?vue&type=script&lang=js"
export * from "./MobileNavMenu.vue?vue&type=script&lang=js"
import style0 from "./MobileNavMenu.vue?vue&type=style&index=0&id=08359478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08359478",
  null
  
)

export default component.exports